export const api = {
  AUTOSHIP_CARD: '/autoship-card',
  AUTOSHIP_SUBSCRIPTION: '/autoship-subscription',
}
